import { createSlice } from '@reduxjs/toolkit';
import { fetchFooterSocialLinks } from '../actions/FooterSocialLinksAction';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const footerSocialLinksSlice = createSlice({
  name: 'footerSocialLinks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFooterSocialLinks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFooterSocialLinks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.error = null;
      })
      .addCase(fetchFooterSocialLinks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'حدث خطأ أثناء جلب روابط السوشيال';
      });
  },
});

export default footerSocialLinksSlice.reducer; 